import React, { useState } from "react";
import { Card, ButtonGroup, Button } from "react-bootstrap";

export default function AttendanceTrends() {
  const [active, setActive] = useState("1Y");
  const [hoverIndex, setHoverIndex] = useState(null);

  const dataSets = {
    "1D": [40],
    "7D": [20, 30, 50, 40, 60, 80, 70],
    "1M": [40, 20, 60, 30, 80, 50, 90, 70],
    "1Y": [40, 22, 52, 25, 55, 90, 43, 25, 68, 80, 35, 20],
  };

  const labels = [
    "Jan","Feb","Mar","Apr","May","Jun",
    "Jul","Aug","Sep","Oct","Nov","Dec"
  ];

  const data = dataSets[active];

  return (
    <Card className="trend-card h-100">
      <Card.Body>

        {/* HEADER */}
        <div className="trend-header card-header-custom">
          <h5>Attendance Trends</h5>

          <ButtonGroup className="trend-filter text-dark">
            {["1D", "7D", "1M", "1Y"].map((item) => (
              <Button
                key={item}
                onClick={() => setActive(item)}
                className={active === item ? "active-btn text-dark" : " text-dark"}
              >
                {item}
              </Button>
            ))}
          </ButtonGroup>
        </div>

        {/* GRAPH */}
        <div className="chart-wrapper">

          {/* Y AXIS */}
          <div className="y-axis">
            {[100, 80, 60, 40, 20, 0].map((val) => (
              <span key={val}>{val}%</span>
            ))}
          </div>

          {/* BARS */}
          <div className="bars">
            {data.map((value, i) => (
              <div
                className="bar-item"
                key={i}
                onMouseEnter={() => setHoverIndex(i)}
                onMouseLeave={() => setHoverIndex(null)}
              >
                <div className="bar-bg">
                  <div
                    className={`bar-fill ${
                      labels[i] === "Jun" ? "highlight" : ""
                    }`}
                    style={{ height: `${value}%` }}
                  >
                    {/* CENTER LABEL */}
                    {labels[i] === "Jun" && (
                      <span className="center-label">90%</span>
                    )}

                    {/* TOOLTIP */}
                    {hoverIndex === i && (
                      <div className="custom-tooltip">
                        <div className="tooltip-title">
                          {labels[i]}
                        </div>
                        <div className="tooltip-body">
                          <span className="dot"></span>
                          Attendance: <b>{value}%</b>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <span className="label">{labels[i]}</span>
              </div>
            ))}
          </div>
        </div>
      </Card.Body>

      {/* ✅ UPDATED CSS */}
      <style>{`
/* CARD */
.trend-card {
  border-radius: 5px;
  border: 2px solid #e5e7eb;
}

 
/* HEADER */
.trend-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.trend-header h6 {
  font-weight: 600;
}

/* FILTER */
.trend-filter button {
  border: none;
  background: #f3f4f6;
  font-size: 12px;
  padding: 6px 12px;
}

.active-btn {
  background: #ff6a00 !important;
  color: #fff !important;
  border-radius: 50px !important;
}

/* CHART HEIGHT INCREASED */
.chart-wrapper {
  display: flex;
  gap: 20px;
  height: 300px;   /* 🔥 increased height */
}

/* Y AXIS */
.y-axis {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 12px;
  color: #6b7280;
}

/* BARS */
.bars {
  display: flex;
  justify-content: space-between;
  flex: 1;
}

/* BAR ITEM */
.bar-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
}

/* 🔥 BAR WIDTH INCREASED */
.bar-bg {
  width: 40px;   /* increased from 24px */
  height: 100%;
  background: repeating-linear-gradient(
    to top,
    #f1f1f1,
    #f1f1f1 25px,
    #fafafa 25px,
    #fafafa 50px
  );
  border-radius: 9px;
  display: flex;
  align-items: flex-end;
}

/* BAR FILL */
.bar-fill {
  width: 100%;
  background: #e6bdb5;
  border-radius: 9px;
  position: relative;
  transition: 0.3s;
}

.bar-fill.highlight {
  background: linear-gradient(to top, #ff6a00, #ff0000);
}

/* CENTER LABEL */
.center-label {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #111827;
  color: #ffff !important ;
  font-size: 11px;
  padding: 3px 7px;
  border-radius: 6px;
}

/* TOOLTIP */
.custom-tooltip {
  position: absolute;
  bottom: 115%;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  border-radius: 10px;
  padding: 12px;
  width: 160px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.15);
  z-index: 10;
}

.tooltip-title {
  font-size: 14px;
  margin-bottom: 6px;
  color: #111;
}

.tooltip-body {
  font-size: 13px;
  color: #444;
  display: flex;
  align-items: center;
  gap: 6px;
}

.tooltip-body .dot {
  width: 8px;
  height: 8px;
  background: #e6bdb5;
  border-radius: 50%;
}

/* LABEL */
.label {
  margin-top: 8px;
  font-size: 12px;
  color: #6b7280;
}

/* MOBILE */
@media (max-width: 1024px) {
  .trend-card {
    margin-bottom: 20px;
  }

  .chart-wrapper {
    height: 260px; /* smaller for mobile */
  }

  .bar-bg {
    width: 22px;
  }
}
  /* MOBILE */
@media (max-width: 1024px) {

  .trend-card {
    margin-bottom: 20px;
  }

  /* HEADER STACK */
  .trend-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

/* NORMAL BUTTON */
.filter-btn {
  border: none;
  background: transparent;
  color: #111827;   /* ✅ DARK TEXT */
  font-size: 13px;
  padding: 6px 12px;
  border-radius: 50px;
}

/* ACTIVE BUTTON (ORANGE) */
.active-btn {
  background: linear-gradient(to right, #ff6a00, #ff0000);
  color: #fff !important;
}

/* OPTIONAL HOVER */
.filter-btn:hover {
  background: #f3f4f6;
}

  /* CHART WRAPPER */
  .chart-wrapper {
    height: 220px;
    gap: 10px;
    overflow-x: auto;   /* 🔥 important for small screens */
  }

  /* Y AXIS SMALL */
  .y-axis {
    font-size: 10px;
  }

  /* BARS SCROLLABLE */
  .bars {
    min-width: 500px; /* 🔥 prevents squishing */
  }

  /* BAR WIDTH SMALL */
  .bar-bg {
    width: 18px;
    border-radius: 6px;
  }

  /* LABEL SMALL */
  .label {
    font-size: 10px;
  }

  /* TOOLTIP ADJUST */
  .custom-tooltip {
    width: 130px;
    padding: 8px;
    font-size: 11px;
  }

  .tooltip-title {
    font-size: 12px;
  }

  .tooltip-body {
    font-size: 11px;
  }

  /* CENTER LABEL SMALL */
  .center-label {
    font-size: 9px;
    padding: 2px 5px;
  }
}

/* EXTRA SMALL DEVICES */
@media (max-width: 480px) {

  .chart-wrapper {
    height: 200px;
  }

  .bar-bg {
    width: 14px;
  }

  .bars {
    min-width: 420px;
  }
}
      `}</style>
    </Card>
  );
}